<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { loadMicroApp } from "qiankun";
import router from "@/router"
export default {
  name: "App",
  mounted() {
   
     
    // 单机运维
    if (this.$route.path.indexOf("saasH_") > -1) { //this.$route.path.indexOf("saasH_") > -1
      console.log(111111)
      loadMicroApp({
        name: "单机运维Saas",
        entry: process.env.VUE_APP_DANJI  + this.$route.path,
        container: "#app",
        props:{type: 'saas',router}
      });
    }

    if (this.$route.path.indexOf("cashierH_") > -1) {
      console.log(111111)
      loadMicroApp({
        name: "阳光收银",
        entry: process.env.VUE_APP_SHOUYIN  + this.$route.path,
        container: "#app",
        props:{type: 'shouyin',router}
      });
    }
    // 权限管理
    if (this.$route.path.indexOf("/saasPer_") > -1) {
      console.log(111111)
      loadMicroApp({
        name: "权限管理",
        entry: process.env.VUE_APP_QUANXIAN  + this.$route.path,
        container: "#app",
      });
    }
  },
};
</script>

<style>
#app {
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  background: #f5f5f6;
}
</style>
